class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
		this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble');
		cartLink.setAttribute('role', 'button');
		cartLink.setAttribute('aria-haspopup', 'dialog');
		cartLink.addEventListener('click', (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener('keydown', (event) => {
			if (event.code.toUpperCase() === 'SPACE') {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add('animate', 'active');
		});

		this.addEventListener(
			'transitionend',
			() => {
				const containerToTrapFocusOn = this.classList.contains('is-empty')
					? this.querySelector('.drawer__inner-empty')
					: document.getElementById('CartDrawer');
				const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add('overflow-hidden');
	}

	close() {
		this.classList.remove('active');
		removeTrapFocus(this.activeElement);
		document.body.classList.remove('overflow-hidden');
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector('.drawer__inner').classList.contains('is-empty') &&
			this.querySelector('.drawer__inner').classList.remove('is-empty');
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			console.log(parsedState.sections);
			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
		});

		setTimeout(() => {
			this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer',
				selector: '#CartDrawer',
			},
			{
				id: 'cart-icon-bubble',
			},
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__inner',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerProductAddons extends HTMLElement {
	constructor() {
		super();

		this.setupAddonProductsCarousel();
	}

	setupAddonProductsCarousel() {
		const addOnProducts = this.querySelector('.js-product-addons');
		if (!addOnProducts) return;

		const flkty = new Flickity(addOnProducts, {
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: false,
			adaptiveHeight: true,
			freeScroll: true,
		});
	}
}

customElements.define('cart-drawer-product-add-ons', CartDrawerProductAddons);

class CartProgressShipping extends HTMLElement {
	constructor() {
		super();

		this.progressBar = this.querySelector('.js-progressBar');
		this.money = this.querySelector('.js-money');

		this.shippingMore = this.querySelector('.js-shipping-more');
		this.shippingText = this.querySelector('.js-shipping-free');

		this.renderCurrentProgress();
	}

	connectedCallback() {}

	renderCurrentProgress() {
		const minPrice = this.dataset.min;
		const currentCartSubTotal = this.dataset.current;
		const shopCurrency = this.dataset.shopCurrency;
		const currentCurrency = this.dataset.currentCurrency;
		const moneyFormater = this.dataset.format;

		if (!minPrice || !currentCartSubTotal || !shopCurrency || !currentCurrency || !window?.Currency?.convert) {
			this.classList.add('hidden');
		}

		const minPriceByCurrentCurrency = window.Currency.convert(minPrice, shopCurrency, currentCurrency);
		const percent = (parseFloat(currentCartSubTotal) / parseFloat(minPriceByCurrentCurrency)) * 100;

		const price = (parseFloat(minPriceByCurrentCurrency) - parseFloat(currentCartSubTotal)).toFixed(2);
		const formatPrice = formatMoney(price, moneyFormater);

		this.money.innerHTML = percent < 100 ? formatPrice : '';

		if (percent >= 100) {
			this.shippingText.classList.remove('hidden');
			this.shippingMore.classList.add('hidden');
		} else {
			this.shippingText.classList.add('hidden');
			this.shippingMore.classList.remove('hidden');
		}

		this.progressBar.style.setProperty('--progress-shipping-bar', `${percent > 100 ? 100 : percent}%`);
		this.progressBar.classList?.[`${percent > 100 ? 'add' : 'remove'}`]('is-full');
	}
}

customElements.define('cart-progress-shipping', CartProgressShipping);

